/**
 * La cola HITL en sidepane: «el pulso del Studio, siempre presente» en las
 * pantallas de trabajo. Resumen de COLA_SEED (cola.seed.tsx, canon F6):
 * P1 + los dos primeros P2 (`sidepane: true` → 5 de las 7; la pantalla
 * completa vive en /cola). Resolver actúa en local (M1, sin motor) igual
 * que el prototipo. Atajos A/E/R: los dispara la propia HitlCard con foco.
 */
import { useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { Empty, HitlCard, Kbd, QLane, Sidepane, useToast } from "@skein/ui";
import { buildActions, COLA_SEED, type QueueCard, type QueueLane } from "./cola.seed";

export function QueuePane() {
  const say = useToast();
  const navigate = useNavigate();
  const [gone, setGone] = useState<Set<string>>(new Set());
  const [left, setLeft] = useState<Set<string>>(new Set());

  const resolve = (id: string, done: string) => {
    setGone((g) => new Set(g).add(id));
    window.setTimeout(() => setLeft((l) => new Set(l).add(id)), 280);
    say(done);
  };
  const cards = COLA_SEED.filter((c) => c.sidepane && !left.has(c.id));
  const lane = (l: QueueLane) => cards.filter((c) => c.lane === l);
  const render = (c: QueueCard) => {
    const actions = buildActions(c, {
      resolve: (done) => resolve(c.id, done),
      navigate: (a) => void navigate({ to: a.to, params: a.params }),
      say,
    });
    return <HitlCard key={c.id} kind={c.kind} act={c.tipo === "activacion"} sla={c.sla} late={c.late} title={c.title} leaving={gone.has(c.id)} rows={c.rows} actions={actions} />;
  };
  return (
    <Sidepane className="queue" aria-label="Cola de revisión" title="Cola de revisión" count={cards.length} hot={cards.length > 0}
      keys={<span className="keys"><Kbd>A</Kbd><Kbd>E</Kbd><Kbd>R</Kbd></span>}>
      {lane("p1").length > 0 && <QLane>hoy</QLane>}
      {lane("p1").map(render)}
      {lane("p2").length > 0 && <QLane p={2}>esta semana</QLane>}
      {lane("p2").map(render)}
      {cards.length === 0 && <Empty glyph="✳" title="Cola vacía">El taller respira — lo urgente está hecho y lo importante, curándose.</Empty>}
    </Sidepane>
  );
}
